import {action, observable} from "mobx";
import {bind} from "Mri.Web.Common";
import {AccountStore, IUserGridColumnPreset, NO_ACTIVE_PRESET} from "../../../Account/AccountStore";
import {AppStore} from "../../../Core/AppStore";
import {IGridColumnSearchItem} from "../FindColumnSearcher";
import {DisplayListViewModel} from "../../../DisplayFilters/DisplayListViewModel";

export class ColumnStateManager {
    constructor(
        private accountStore: AccountStore,
        private appStore: AppStore,
        private vm: DisplayListViewModel,
    ) {}

    @bind
    @action
    public applyPresetColumns() {
        let gridColumnPresets = this.accountStore.storage.gridColumnPresets || [];
        let preset = this.accountStore.tabStorage.activeGridColumnPreset;
        let activePreset = gridColumnPresets.find(p => p.name == preset);
        let noActivePresetColumns = this.accountStore.storage.noActivePresetGridColumns;
        let activeColumns = this.accountStore.tabStorage.activeGridColumns;

        if (activePreset) {
            this.appStore.gridRef?.api.applyColumnState({ state: activePreset.columns, applyOrder: true });
        } else if (noActivePresetColumns) {
            this.appStore.gridRef?.api.applyColumnState({ state: noActivePresetColumns, applyOrder: true });
        } else if (activeColumns) {
            this.appStore.gridRef?.api.applyColumnState({ state: activeColumns, applyOrder: true });
        } else {
            const columns2 = [
                "rowNum",
                "serialNumber",
                "accountName",
                "contract",
                "unitLocation.city",
                "unitLocation.country",
                "unitLocation.stateOrProvince",
            ];

            if (this.appStore.gridRef != null) {
                this.appStore.gridRef.api.setColumnsVisible(columns2, true);
            }
        }

        if(this.accountStore.tabStorage.activeGridColumnPreset && !this.accountStore.storage.activeGridColumnPreset) {
            this.accountStore.storage.activeGridColumnPreset = this.accountStore.tabStorage.activeGridColumnPreset;
        }

        this.initialPresetApplied = true;
    }

    @bind
    @action
    public updateSearchableGridColumns() {
        let columns = this.appStore.gridRef?.api.getAllDisplayedColumns();

        if (columns) {
            this.vm.searchableGridColumns = columns.map(c => {
                let headerName = c.getColDef().headerName || c.getColId();
                return {
                    colId: c.getColId(),
                    headerName: headerName.charAt(0).toUpperCase() + headerName.slice(1)
                } as IGridColumnSearchItem;
            })
        }
    }

    @bind
    @action
    public updateActiveTabColumns() {
        let currentColumns = this.appStore.gridRef?.api.getColumnState();
        if(currentColumns) {
            this.accountStore.tabStorage.activeGridColumns = currentColumns;
        }
    }

    @bind
    @action
    public async overwriteActivePreset() {
        if (!this.appStore.gridInitialized || !this.initialPresetApplied) return;

        if (!this.accountStore.tabStorage.activeGridColumnPreset || this.accountStore.tabStorage.activeGridColumnPreset == NO_ACTIVE_PRESET) {
            this.updateNoActivePresetGridColumns();
            return;
        }

        if (!this.accountStore.storage.gridAutoUpdatePresets) return;

        let preset = this.accountStore.storage.gridColumnPresets.find(
            (p: IUserGridColumnPreset) => p.name == this.accountStore.tabStorage.activeGridColumnPreset
        );
        let currentColumns = this.appStore.gridRef?.api.getColumnState();

        if(preset && currentColumns != null) {
            // Remove the existing preset with the same name
            this.accountStore.storage.gridColumnPresets = this.accountStore.storage.gridColumnPresets.filter(
                (p: IUserGridColumnPreset) => p.name !== this.accountStore.tabStorage.activeGridColumnPreset
            );

            // Update the columns
            preset.columns = currentColumns;

            // Add the updated preset to the beginning of the array
            this.accountStore.storage.gridColumnPresets.unshift(preset);

            // Set the active preset name
            this.accountStore.tabStorage.activeGridColumnPreset = preset.name;
        }
    }

    @bind
    @action
    private updateNoActivePresetGridColumns(){
        let currentColumns = this.appStore.gridRef?.api.getColumnState();
        if(currentColumns != null && this.appStore.gridInitialized) {
            this.accountStore.storage.noActivePresetGridColumns = currentColumns;
        }
    }

    @observable
    private initialPresetApplied = false;
}
